import Hero from "../components/sections/Hero";
import Proyects from "../components/sections/Proyects";
import Experience from "../components/sections/Experience";
import About from "../components/sections/About";
import FeaturedProject from "../components/sections/FeaturedProject";
import Contact from "../components/sections/Contact";
export default function IndexPage() {
  return (
    <main className="overflow-hidden">
      <Hero />
      <Experience />
      <FeaturedProject />
      <Proyects />
      <Contact />
    </main>
  );
}
